import { Formik, Form } from "formik";
import { useState } from "react";
import { Modal } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { OK } from "../../../constants/statusCode";
import { getUserVerify } from "../../../features/userManagement/userVerifySlice";
// import { showSuccess } from "../../../utils/messageHelper";
import Button from "../../form-components/Button";
import Fields from "../../form-components/Fields";
import eyeline from "../../../assets/images/eyelineicn.svg";
import eye from "../../../assets/images/eyeicn.svg";
import { getUserList } from "../../../features/userManagement/getUserListSlice";
import userVerify from "../../../validations/userModuleValidation/userVerify";

const UserVerify = ({ isOpen, toggel, userUUID, userEmail, perPage, currentPage, setCurrentActiveTab }) => {
    let dispatch = useDispatch();
    const [togglePassword, setTogglePassword] = useState(false);
    let projectData = JSON.parse(localStorage.getItem("_user"));

    const doSubmit = async (values) => {
        let newObj = {};
        newObj.email = values.email;
        newObj.password = values.password;
        newObj.user_uuid = userUUID;
        let { payload } = await dispatch(getUserVerify(newObj));
        if (payload.status === OK) {
            toggel();
            setCurrentActiveTab("allUsers");
            dispatch(getUserList({ perPage: perPage, page: currentPage, isActive: 1, organization_uuid: projectData?.organizations[0].uuid }));
            // showSuccess("User verify successfully!");
        }
    }

    return (
        <>
            <Modal
                className="add-document-popup"
                show={isOpen}
                onHide={toggel}
                centered={true}
                // modalTransition={{ timeout: 2000 }}
                dialogClassName="common-modal"
            >
                <Modal.Header>
                    <h3 className="modal-title" id="Add_OrganizationLabel">{'Verify User'}</h3>
                    {/* <button type='button' className='btn d-flex dlet-btn me-2'><img src="/static/media/trash.72657b09efa409e79727b60dd2c7bc45.svg" alt="" />
                </button> */}
                    <Button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={() => { toggel(); }}></Button>

                </Modal.Header>

                <>
                    <Formik
                        initialValues={{
                            email: userEmail || '',
                            password: '',
                        }}
                        validationSchema={userVerify}
                        onSubmit={doSubmit}
                    >
                        {({
                            values,
                            handleChange,
                            handleBlur,
                            touched,
                            errors,
                            isSubmitting,
                            handleSubmit,
                        }) => (
                            <Form>
                                <Modal.Body>
                                    <div className="col-md-12">
                                        <label className="form-label">Email</label>
                                        <div className="form-group">
                                            <Fields
                                                type="email"
                                                placeholder="Add Email"
                                                className="form-control"
                                                touched={touched}
                                                errors={errors}
                                                onBlur={handleBlur}
                                                name="email"
                                                value={values.email}
                                                onChange={handleChange}
                                            />
                                        </div>
                                    </div>
                                    <label className="form-label">Password</label>
                                    <div className="form-group form-grp-passsword">
                                        <Fields
                                            type={togglePassword ? "text" : "password"}
                                            placeholder="Password"
                                            touched={touched}
                                            errors={errors}
                                            onBlur={handleBlur}
                                            name="password"
                                            value={values.password}
                                            className="form-control"
                                            onChange={handleChange}
                                        />
                                        <span
                                            className={`icon-${togglePassword ? "Hide" : "Hide"}`}
                                            onClick={() => setTogglePassword(!togglePassword)}
                                        >
                                            <img
                                                className="eye-icn"
                                                src={togglePassword ? eye : eyeline}
                                                alt="show password"
                                            />
                                        </span>
                                    </div>
                                </Modal.Body>
                                <Modal.Footer>
                                    <Button type="button" disabled={isSubmitting} className="btn btn-primary-md" onClick={handleSubmit}>Create</Button>
                                </Modal.Footer>
                            </Form>
                        )}
                    </Formik>
                </>
            </Modal>
        </>
    );
}

export default UserVerify;